import React, { useState, cloneElement, useEffect } from 'react';
import Button from '../../atoms/button/button';
import { IconType, IconSize } from '../../atoms/icon/icon';
import './hamburgerMenu.scss';
import Menu from '../menu/menu';

const HamburgerMenu = (props) => {
  const { id,children,isOpen,onOpen } = props;
  const [active, setActive] = useState(false);
  const [myIsOpen,setMyIsOpen]=useState(isOpen);
  const backgroundColor = process.env.REACT_APP_BACKGROUND_COLOR;
  const menuButtonColor = process.env.REACT_APP_MAIN_MENU_BUTTON_COLOR;
  const [render,setRender]=useState(null);
  const handleClick = () => {
    setActive(!active);
    onOpen(active=="si"?"si":"no");
  };
  useEffect(()=>{
    setActive(isOpen!="no");
    
  },[isOpen]);
  useEffect(()=>{
    // let myRender=[];
    // let myRender=[
    
    //   <Button
    //     id={id}
    //     key="hamburgerMenu-1"
    //     icon={IconType.MENU}
    //     iconSize={IconSize.LARGE}
    //     iconColor={"#"+menuButtonColor}
    //     onClick={handleClick}
    //   />,
    // ];
      
      // myRender.push(
      // <div key="hamburgerMenu-2" className={active?"hamburger-menu__container active":"hamburger-menu__container"} style={{backgroundColor: "#"+backgroundColor}}>
      //         <div className='hamburger-menu__title'>YBVR</div>
      //         <div>test</div>
      //         {/* <Menu>
      //           {children.map((child) => {
      //             console.log("jjjjj",child!=false);
      //             if (child != false) return child;//cloneElement(child, { onClick: handleClick });
      //           })
      //           }
      //         </Menu>  */}
      // </div>
      // );
    // myRender.push(

    //       <div key="hamburgerMenu-2" className={active?"hamburger-menu__container active":"hamburger-menu__container"} style={{backgroundColor: "#"+backgroundColor}}>
    //         <div className='hamburger-menu__title'>YBVR</div>
    //         <Menu>
    //           {
    //           children.map((child) => {
    //             if (child != false) return cloneElement(child, { onClick: handleClick });
    //           })
    //           }
    //         </Menu>
    //       </div>,
    //     );
    //     console.log("children",children);
        // setRender(myRender);
  },[children]);

  // const urender = [
  //   <Button
  //     id={id}
  //     key="hamburgerMenu-1"
  //     icon={IconType.MENU}
  //     iconSize={IconSize.LARGE}
  //     iconColor={"#"+menuButtonColor}
  //     onClick={handleClick}
  //   />,
  // ];

  // if (active) {
    // render.push(
    //   <div key="hamburgerMenu-2" className={active?"hamburger-menu__container active":"hamburger-menu__container"} style={{backgroundColor: "#"+backgroundColor}}>
    //     <div className='hamburger-menu__title'>YBVR</div>
    //     <Menu>
    //       {
    //       children.map((child) => {
    //         if (child != false) return cloneElement(child, { onClick: handleClick });
    //       })
    //       }
    //     </Menu>
    //   </div>,
    // );
  // }

  return <>
    <Button
        id={id}
        key="hamburgerMenu-1"
        icon={IconType.MENU}
        iconSize={IconSize.LARGE}
        iconColor={"#"+menuButtonColor}
        className="hamburguerMenu"
        onClick={handleClick}
    />
    {  <div key="hamburgerMenu-2" className={active?"hamburger-menu__container active":"hamburger-menu__container"} style={{backgroundColor: "#"+backgroundColor}}>
              <div className='hamburger-menu__title'>YBVR</div>
       <Menu>
                {children.map((child) => {
                  if (child != false) return child;//cloneElement(child, { onClick: handleClick });
                })
                }
               <div className="version">{process.env.REACT_APP_VERSION || 'unknown'}</div>
        </Menu> 
      </div>}

  </>;

  
};

export default HamburgerMenu;
